// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/home',
    name: 'Home',
    component: layout,
    redirect: '/home/index',
    meta: {
      title: '首页',
      icon: 'i-menu:home',
      i18Key: 'router.user.home.title',
      roles: [1]
    },
    sort: 1,
    children: [
      {
        path: 'index',
        name: 'HomeIndex',
        component: () => import('@/views/Home/Index.vue'),
        meta: {
          title: '首页',
          icon: 'i-menu:home',
          i18Key: 'router.user.home.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn']
        }
      }
    ]
  }
]
export default routes
